import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import { useAppSelector } from '@/utils/redux';

/**
 * Single source of truth for whether the conditions sidebar is mounted on the explore trail page.
 *
 * The @sidebar layout uses it to decide what to render, and the map legend uses it to decide who owns the
 * day/time controls. Both must agree: if they drift apart the page ends up with two day pickers, or with
 * none at all when the waypoint sidebar takes the slot.
 */
const useIsConditionsSidebarMounted = () => {
  const isMobile = useIsMobileSizedScreen();
  const { activeCondition, conditionsPanelOpen, hasSelectedWaypoint, hasTrail } = useAppSelector(state => ({
    activeCondition: state.conditions.activeCondition,
    // Set by useExploreConditions rather than derived here, so an overlay carried over from another explore page
    // doesn't take the sidebar the moment a trail is opened.
    conditionsPanelOpen: state.explore.conditionsPanelOpen,
    // A clicked waypoint takes over the sidebar slot ahead of conditions, matching the trail map.
    hasSelectedWaypoint: state.map.selectedWaypoint !== undefined,
    // Explore pages without a trail have nothing to show conditions for, so the map legend keeps the controls.
    hasTrail: state.explore.currentTrail?.id !== undefined
  }));

  return !isMobile && !hasSelectedWaypoint && conditionsPanelOpen && activeCondition !== undefined && hasTrail;
};

export default useIsConditionsSidebarMounted;
